// Import bootstrap
import * as bootstrap from 'bootstrap';

// Import our SCSS
import '../scss/main.scss';

// Your custom JavaScript here

// Update URL hash when a Bootstrap tab is activated
document.addEventListener('DOMContentLoaded', function () {
  const tabLinks = document.querySelectorAll('a[data-bs-toggle="tab"]');

  const dropdownLinkToggles = document.querySelectorAll(
    'a.js-space-dropdown-toggle[data-bs-toggle="dropdown"]',
  );
  // Activate tab from hash on page load
  if (window.location.hash) {
    const hash = window.location.hash.replace('#', '');
    const tabToShow = document.getElementById(hash);
    if (tabToShow && tabToShow.getAttribute('data-bs-toggle') === 'tab') {
      const tabInstance = bootstrap.Tab.getOrCreateInstance(tabToShow);
      tabInstance.show();
    }
  }

  tabLinks.forEach(function (tab) {
    tab.addEventListener('shown.bs.tab', function (event) {
      if (event.target && event.target.id) {
        // Update the hash in the URL bar
        history.replaceState(null, '', '#' + event.target.id);
      }
    });
  });

  dropdownLinkToggles.forEach(function (toggle) {
    toggle.addEventListener('keydown', function (event) {
      if (event.key === ' ' || event.code === 'Space' || event.key === 'Spacebar') {
        event.preventDefault();
        const dropdown = bootstrap.Dropdown.getOrCreateInstance(toggle);
        dropdown.toggle();
      }
    });
  });

  // Remove aria-hidden from sr7 overlay layers on /wellness/wellness-wheel/ to allow screen readers to access the content within the layers. The layers are still visually hidden with CSS, but this allows screen reader users to access the content and interact with the buttons within the layers.
  if (window.location.pathname.startsWith('/wellness/wellness-wheel/')) {
    setTimeout(() => {
      document
        .querySelectorAll('.sr7-layer, .sr7-layer.sr7-btn, .sr7-btn.sr7-layer')
        .forEach(function (el) {
          el.removeAttribute('aria-hidden');
        });
    }, 1000);
  }
});

// Revolution Slider: whenever a .sr7-layer.sr7-btn element is marked aria-hidden="true" (set by the slider itself), also set tabindex="-1" on it so it can't be reached via keyboard nav.
document.addEventListener('DOMContentLoaded', function () {
  var SR7_BUTTON_SELECTOR = '.sr7-layer.sr7-btn';

  function syncSr7ButtonAccessibility(el) {
    var hidden = el.getAttribute('aria-hidden') === 'true';

    if (hidden) {
      el.setAttribute('tabindex', '-1');
    } else {
      el.removeAttribute('tabindex');
    }
  }

  function syncAllSr7Buttons() {
    document.querySelectorAll(SR7_BUTTON_SELECTOR).forEach(syncSr7ButtonAccessibility);
  }

  function watchSr7Button(el) {
    if (el.dataset.a11yWatched) {
      return;
    }
    el.dataset.a11yWatched = 'true';
    syncSr7ButtonAccessibility(el);

    new MutationObserver(function () {
      syncSr7ButtonAccessibility(el);
    }).observe(el, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function initSr7Buttons() {
    document.querySelectorAll(SR7_BUTTON_SELECTOR).forEach(watchSr7Button);
  }

  initSr7Buttons();

  // debounce the DOM scan so it runs at most once per animation frame
  var scanScheduled = false;
  function scheduleSr7Scan() {
    if (scanScheduled) {
      return;
    }
    scanScheduled = true;
    window.requestAnimationFrame(function () {
      scanScheduled = false;
      initSr7Buttons();
    });
  }

  // keep watching the page for buttons that render markup after DOMContentLoaded
  new MutationObserver(scheduleSr7Scan).observe(document.body, { childList: true, subtree: true });

  window.lsscSyncSr7ButtonsA11y = syncAllSr7Buttons;
});

// Fade out the chat CTA when the user scrolls down, and fade it back in when they scroll back to the top
document.addEventListener('DOMContentLoaded', function () {
  var chatCta = document.getElementById('chat-cta');
  var faded = false;
  window.addEventListener('scroll', function () {
    if (window.scrollY > 20) {
      if (!faded) {
        chatCta.classList.add('fade-out');
        faded = true;
      }
    } else {
      if (faded) {
        chatCta.classList.remove('fade-out');
        faded = false;
      }
    }
  });
});
